const ModalFooter = ({ children, className }) => {
	return <div className={`p-3 ${className ? className : ""}`}>{children}</div>;
};

export default ModalFooter;
